import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { PartBrandDomainRequest } from "@/main/models/request";

export abstract class IBrandApi {
	abstract getDomain(request: PartBrandDomainRequest | null): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
